import { useEffect } from "react";
import { useLocation } from "react-router";

const ChangeBackground = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (
      // pathname === "/match" ||
      // pathname.match(/\/match\/(\d+)/) ||
      // pathname.match(/\/questions\/(\d+)/) ||
      // pathname.match(/\/lig\/(\d+)/) ||
      pathname === "/leaderboard" ||
      pathname === "/scoreHistory" ||
      pathname === "/goldenCard" ||
      pathname.match(/\/scoreHistory\/(\d+)/)
    ) {
      document.body.classList.add("SecondaryBg");
    }
    return () => {
      document.body.classList.remove("SecondaryBg");
    };
  }, [pathname]);
  return null;
};

export default ChangeBackground;
